import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
interface WhatsAppButtonProps {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}
export const WHATSAPP_URL = 'https://chat.whatsapp.com/K5D6XJJMot41t9dhoBpRl4?mode=gi_';
export function WhatsAppButton({
  children,
  className = '',
  showIcon = true
}: WhatsAppButtonProps) {
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        inline-flex items-center justify-center gap-3 
        bg-whatsapp hover:bg-whatsappHover text-white 
        font-bold py-4 px-8 rounded-full 
        shadow-[0_8px_20px_rgba(37,211,102,0.4)]
        hover:shadow-[0_12px_25px_rgba(37,211,102,0.5)]
        transition-all duration-300
        ${className}
      `} data-id="element-113">
      {showIcon && <MessageCircle className="w-6 h-6 fill-white" data-id="element-114" />}
      <span className="text-lg md:text-xl uppercase tracking-wide" data-id="element-115">
        {children}
      </span>
    </motion.a>;
}